import { PlainSearchParameters } from 'algoliasearch-helper'
import { parseContentIndexName } from '@app-lib/search-index.lib'
import { ContentSearchInput } from '@app-domains/meilisearch/types/content-search.types'

export function mapContentInstantSearchRequest(
    indexName: string,
    params: PlainSearchParameters,
): ContentSearchInput {
    const { locale } = parseContentIndexName(indexName)

    return {
        query: params.query ?? '',
        locale,
        page: (params.page ?? 0) + 1,
        perPage: params.hitsPerPage !== undefined ? params.hitsPerPage : 24,
    }
}
